export const formatSQL = (sql: string): string => {
  // Basic SQL keywords to highlight
  const keywords = [
    'SELECT',
    'FROM',
    'WHERE',
    'GROUP BY',
    'ORDER BY',
    'HAVING',
    'JOIN',
    'INNER',
    'LEFT',
    'RIGHT',
    'FULL',
    'OUTER',
    'ON',
    'AND',
    'OR',
    'NOT',
    'IN',
    'EXISTS',
    'BETWEEN',
    'LIKE',
    'INSERT',
    'UPDATE',
    'DELETE',
    'CREATE',
    'ALTER',
    'DROP',
    'TABLE',
    'VIEW',
    'INDEX',
    'TRIGGER',
    'PROCEDURE',
    'FUNCTION',
    'BEGIN',
    'END',
    'IF',
    'ELSE',
    'THEN',
    'CASE',
    'WHEN',
    'NULL',
    'TRUE',
    'FALSE',
    'ASC',
    'DESC',
    'LIMIT',
    'OFFSET',
  ];

  let formattedSQL = sql;

  // Highlight keywords
  keywords.forEach((keyword) => {
    const regex = new RegExp(`\\b${keyword}\\b`, 'gi');
    formattedSQL = formattedSQL.replace(
      regex,
      `<span class="keyword">${keyword}</span>`
    );
  });

  // Highlight strings (text between single quotes)
  formattedSQL = formattedSQL.replace(
    /'[^']*'/g,
    '<span class="string">$&</span>'
  );

  // Highlight numbers
  formattedSQL = formattedSQL.replace(
    /\b\d+\b/g,
    '<span class="number">$&</span>'
  );

  return formattedSQL;
};
